import React from 'react';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import { Button } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { Banner } from 'interfaces/banner';
import { deleteBanner } from 'redux/ducks/banner';

// import Typography from '@material-ui/core/Typography';

export interface SimpleDialogProps {
  open: boolean;
  onClose: () => void;
  banner: Banner;
  reload: () => void;
}

export default function ModalDeleteBanner(props: SimpleDialogProps) {
  const { onClose, open, banner, reload } = props;

  const dispatch = useDispatch();

  const handleClose = () => {
    onClose();
  };

  const submitDelete = async () => {
    dispatch(deleteBanner(banner?.id)).then((result: number) => {
      if (result === 0) {
        reload();
        handleClose();
      }
    });
  };

  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="simple-dialog-title"
      open={open}
    >
      <DialogTitle id="simple-dialog-title">
        Delete Banner {banner?.placement_title}?
      </DialogTitle>
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <Button onClick={submitDelete} color="primary">
          {' '}
          Delete{' '}
        </Button>
        <Button onClick={handleClose}> Cancel </Button>
      </div>
    </Dialog>
  );
}
